import React from "react";
import SuperAdminPayslips from "../superadmin/payroll/PayslipsPage";

const PayslipsPage = () => {
    return <SuperAdminPayslips />;
};

export default PayslipsPage;
